const devConfig = {
    apiKey: "AIzaSyCO81Yewx9gQ2OsuE8S8u-2-OICu-ZzVmA",
    authDomain: "creatorcv-dea95.firebaseapp.com",
    databaseURL: "https://creatorcv-dea95.firebaseio.com",
    projectId: "creatorcv-dea95",
    storageBucket: "creatorcv-dea95.appspot.com",
    messagingSenderId: "125541107138"
  };
  
  const prodConfig = {
    apiKey: "AIzaSyCO81Yewx9gQ2OsuE8S8u-2-OICu-ZzVmA",
    authDomain: "creatorcv-dea95.firebaseapp.com",
    databaseURL: "https://creatorcv-dea95.firebaseio.com",
    projectId: "creatorcv-dea95",
    storageBucket: "creatorcv-dea95.appspot.com",
    messagingSenderId: "125541107138"
  };
  
  export {
    devConfig,
    prodConfig
  }